import { useQuery } from 'react-query'
import { DetailPaginatedRequest } from '../../../core/interfaces/details-paginated-request'
import { getCustomerAddresses } from '../../customers'

export default function useCustomerAddresses(query: DetailPaginatedRequest) {
  const { data, error, isLoading } = useQuery(
    ['customerAddresses', query],
    () => getCustomerAddresses(query)
  )
  return { data, error, isLoading }
}
